export default __webpack_public_path__ + "static/media/user-not-found.42bc02aa.svg";